<template>
  <div class="amjs-casino">
      <img src="../../assets/images/amjs/card_title.png">
	  <div class="amjs-cont">
		  	<a href="./live" class="live"></a>
			<a href="./chess" class="chess"></a>
			<a href="./sport" class="sport"></a>
			<a href="./lottery" class="lottery"></a>
	  </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.amjs-casino {
	box-sizing: border-box;
	height: 654px;
	padding-top: 50px;
	text-align: center;
	background: url("../../assets/images/amjs/casinobg.jpg") no-repeat center top;
	background-size: 1920px 654px;
	img {
		margin-bottom: 35px;
	}
	.amjs-cont {
		a {
			display: inline-block;
			width: 298px;
			height: 422px;
			vertical-align: top;
			background-size: 100% 100%;
			background-repeat: no-repeat;
			transition: all .3s;
			&.live {
				background-image: url('../../assets/images/amjs/amjs_zr.png');
			}
			&.chess {
				background-image: url('../../assets/images/amjs/amjs_qp.png');
			}
			&.sport {
				background-image: url('../../assets/images/amjs/amjs_ty.png');
			}
			&.lottery {
				background-image: url('../../assets/images/amjs/amjs_cp.png');
			}
			&:hover {
				opacity: .9;
			}
		}
	}
}
</style>